import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: true,
})
export class FileSizePipe implements PipeTransform {
    public transform(size: number): string {
        const binaryPrefixSize = 1024;

        if (size < binaryPrefixSize) {
            return size + ' B';
        }

        if (size < Math.pow(binaryPrefixSize, 2)) {
            return (size / binaryPrefixSize).toFixed(1) + ' KB';
        }

        return (size / Math.pow(binaryPrefixSize, 2)).toFixed(1) + ' MB';
    }
}
